import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: '4px',
    flexDirection: 'column',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
    backgroundColor: '#fff',
  },
  row: {
    height: '44px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    display: 'flex',
    gap: '16px',
    padding: '10px 0px',
    borderRadius: 6,
    alignItems: 'center',
  },
  dateBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '150px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',
  },
  iconWrapper: {
    width: '32px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconCircle: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '50px',
    backgroundColor: 'rgba(250, 250, 254, 1)',
    padding: '5px',
  },
  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    flexGrow: 1,
    minWidth: 0,
  },
  messageText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(43, 44, 53, 1)',
    flexGrow: 1,
  },
  userText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',
    flexGrow: 1,
  },
  noAudit: {
    textAlign: 'center',
    width: '100%',
    padding: '20px',
  },
  mainHeader: {
    height: '70px',
    boxSizing: 'border-box',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    borderBottom: '1px solid #E0E0E0',
  },
  headerText: {
    fontSize: '14px',
    fontWeight: '500',
    color: 'rgba(43, 44, 53, 1)',
    fontStyle: 'normal',
    lineHeight: '21px',
  },
  mainContent: {
    padding: '10px 16px',
    boxSizing: 'border-box',
    minHeight: 'calc(100vh - 140px)',
    maxHeight: 'calc(100vh - 140px)',
    borderBottom: '1px solid #E0E0E0',
    overflowY: 'auto',
  },
  mainTimeline: {
    padding: '0px',
  },
  footer: {
    height: '70px',
    boxSizing: 'border-box',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  closeButton: {
    color: '#3F51B5',
    border: '1px solid #3F51B5',
    borderRadius: '4px',
    height: '35px',
    padding: '12px',
    boxSizing: 'border-box',
  },
}));

export const useAuditTrailsStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      height: 'calc(100vh - 232px)',
    },
    paper: {
      boxShadow: 'none',
      border: '1px solid #EEEEEE !important',
      borderTop: 'none !important'
    },
    header: {
      padding: theme.spacing(2, 3),
      borderBottom: `1px solid ${theme.palette.divider}`,
      textAlign: 'left'
    },
    timeline: {
      padding: '16px'
    },
    opposite: {
      padding: '0px !important',
      color: '#78798E',
      fontSize: '0.75rem',
      minWidth: 180,
      flex: 0.2,
      textAlign: 'left',
      alignContent: 'center'
    },
    title: {
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      color: '#2B2C35',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      display: 'block',
    },
    subtitle: {
      marginTop: 8,
      color: '#78798E',
      fontSize: '0.75rem'
    },
    connector: {
      width: 1,
      background: 'linear-gradient(180deg, #D5D6DD 60%, transparent 40%)',
      backgroundSize: '2px 8px'
    },
    content: {
      textAlign: 'left',
      minWidth: 0,
    },
    dot: {
      height: '1.5rem',
      width: '1.5rem',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%'
    },
    separator: {
      marginTop: '0px',
    },
  })
);
